module.exports = __webpack_public_path__ + "img/buba_yes.a0bfeaf9.png";